import { useMemo } from 'react';
import { useWindowDimensions } from 'react-native';

export default function useDimensions() {
  const { width, height, fontScale, scale } = useWindowDimensions();
  const s = useMemo(() => (window as any).idcScale ?? scale, [scale]);
  return { width, height, fontScale, scale: s };
}
